import { render, staticRenderFns } from "./RegisteredCustomer.vue?vue&type=template&id=f64a7e90"
import script from "./RegisteredCustomer.vue?vue&type=script&lang=js"
export * from "./RegisteredCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports